import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';

const toolName = 'get-html-from-text' as const;

const argumentZod = z.object({
  text: z.array(z.string()).max(5).describe(dedent`
      Text strings to search for on the page (max 5).
    `),
});

export const getHtmlFromTextTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Check elements from text',
  prettyStatus: {
    executing: 'Checking elements from text...',
    executed: 'Checked elements from text',
    failed: 'Failed to check elements from text',
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Returns the HTML sections containing the given text strings on the current page. Use to find elements by visible text content. Returns data-w-id attributes for use with other element tools.

      Reuse this result only while no page-mutating tool or external action has changed the page. After a successful mutation or STALE_CONTEXT response, re-read before using element IDs or markup from an earlier result.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SitePage', action: 'editContent'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
  timeout: 30000, // 30 seconds for removing style property
});
